import { fr } from '@formkit/i18n';

const config = {
    locales: { fr },
    locale: 'fr',
    theme: 'genesis'
}

export default config;